import React, { useState } from "react";
import { CloseSvgIcon } from "Components/SvgIcon/SvgIcon";
import Button from "Components/Button/Button";
import "./modal.css";

const Modal = (
    {
        id,
        className,
        header,
        content,
        modalContainerCss,
        showModalExit,
        onClose,
        ...props
    }) => {
    const [open, toggleOpenClose] = useState(true);

    const close = () => {
        toggleOpenClose(false);

        if (onClose) {
            onClose();
        }
    };

    return (
        <div
            id={`${id ? id : ""}`}
            className={`reactModal ${open ? false : "closed"} ${className ? className : ""}`}
            onClick={() => (showModalExit ? close() : false)}
        >
            <div className="modalContainer" style={modalContainerCss} onClick={(e) => e.stopPropagation()}>
                <div className="modalHeader">
                    {header}
                    {showModalExit ? (
                        <Button
                            className={"modalExit"}
                            variant={"link"}
                            onClick={close}
                            ariaLabel={"Close Modal."}
                        >
                            <CloseSvgIcon />
                        </Button>
                    ) : (
                        false
                    )}
                </div>
                <div className="modalContent">{content}</div>
            </div>
        </div>
    );
};

export default Modal;
